import type { PaymentMethod } from '@shared/contracts/enums'

const comingSoonPaymentMethods = new Set<PaymentMethod>(['PIX', 'BOLETO'])
const walletPaymentMethodValues = new Set<PaymentMethod>(['APPLE_PAY', 'GOOGLE_PAY'])

export const defaultProductPaymentMethods = [
  'CREDIT_CARD',
  'APPLE_PAY',
  'GOOGLE_PAY',
] satisfies PaymentMethod[]

function availablePaymentMethods(methods: readonly PaymentMethod[]): PaymentMethod[] {
  return methods.filter((method) => !comingSoonPaymentMethods.has(method))
}

function uniquePaymentMethods(methods: readonly PaymentMethod[]): PaymentMethod[] {
  return [...new Set(methods)]
}

export function isWalletPaymentMethod(method: PaymentMethod): boolean {
  return walletPaymentMethodValues.has(method)
}

export function normalizeProductPaymentMethods(methods: readonly PaymentMethod[]): PaymentMethod[] {
  const available = uniquePaymentMethods(availablePaymentMethods(methods))
  const baseMethods = available.filter((method) => !isWalletPaymentMethod(method))
  const normalizedBase: PaymentMethod[] = baseMethods.length > 0 ? baseMethods : ['CREDIT_CARD']
  const allowsCard = normalizedBase.includes('CREDIT_CARD')
  const wallets = allowsCard ? available.filter((method) => isWalletPaymentMethod(method)) : []

  return [...normalizedBase, ...wallets]
}

export function normalizeSubscriptionPaymentMethods(
  methods: readonly PaymentMethod[],
): PaymentMethod[] {
  const available = uniquePaymentMethods(availablePaymentMethods(methods))
  const wallets = available.filter((method) => isWalletPaymentMethod(method))

  return ['CREDIT_CARD', ...wallets]
}
